<template>
	<transition name="fade">
		<div class="modal" v-if="shown">
			<div class="modal-dimmer" @click="closeModal" v-if="shown"></div>
			<transition name="fadeDown">
				<div class="modal-content" v-if="fadeIn">
					<div class="box">
						<span class="close" @click="closeModal"><i class="close icon"/></span>
						<div class="box-header">
							<i class="icons" v-if="icons">
                <i :class="[icons, 'icon']"/>
								<i class="ui blue circular label top right" v-if="totalnotifications > 0">{{ totalnotifications }}</i>
							</i>
							{{ title }}
						</div>

						<div class="box-content">
              <slot/>
						</div>

						<div class="box-actions" v-if="showButtons">
							<slot name="box-actions">
								<div class="ui basic circular red button" @click="denyModal">{{ $t('globals.buttons.cancel') }}</div>
								<div class="ui blue circular button" :class="acceptButtonDisabled ? 'disabled' : ''" @click="acceptModal">{{ $t('globals.buttons.next') }}</div>
							</slot>
						</div>
					</div>
				</div>
			</transition>
		</div>
	</transition>
</template>

<script>
	export default {
		name: 'Modal',

		props: {
      showButtons: {
        type: Boolean,
        default: true
      },

      acceptButtonDisabled: {
        type: Boolean,
        default: false
      },

			active: {
				required: true,
				default: false,
				type: Boolean
			},

			popout: {
				required: false,
				default: false,
				type: Boolean
			},

			title: {
				required: true,
				default: null,
				type: String
			},

			icons: {
				required: false,
				default: null,
				type: String
			},

			totalnotifications: {
				required: false,
				default: null,
				type: Number
			}
		},

		data () {
			return {
				shown: false,
				fadeIn: false
			}
		},

		watch: {
			active () {
        if ((this.$route.name === 'checkout' || this.$route.name === 'checkout_overdue_fee' || this.$route.name === 'mobile_pay_success' || this.$route.name === 'vipps_process') && !this.active) {
          this.$emit('denymodal')

          this.fadeIn = false

          setTimeout(() => {
            this.shown = false
          }, 50)
        } else {
          if (this.popout) {
            const body = document.querySelector('body')
            body.appendChild(this.$el)
          }

          this.shown = true

          setTimeout(() => {
            this.fadeIn = true
          }, 50)
        }
			},

			shown (shown) {
				const body = document.querySelector('body')
				const className = 'not-scrollable'

				if (shown) {
					if (body.classList) {
						body.classList.add(className)
					} else {
						body.className += ' ' + className
					}
				} else {
					if (body.classList) {
						body.classList.remove(className)
					} else {
						body.className = body.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ')
					}
				}
			}
		},

		methods: {
			closeModal () {
				this.$emit('denymodal')

				this.fadeIn = false

				setTimeout(() => {
					this.shown = false
				}, 50)
			},

			denyModal () {
				this.$emit('denymodal')
				this.closeModal()
			},

			acceptModal () {
				this.$emit('acceptmodal')
				this.closeModal()
			}
		},

		computed: {
			activeClasses () {
				if (this.active) {
					return 'is-active'
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.modal {
	    position: fixed;
	    height: 100%;
	    width: 100%;
	    top: 0;
	    bottom: 0;
	    left: 0;
	    overflow: hidden;
	    display: flex;
	    z-index: 40;
	    justify-content: center;
	    align-items: center;

	    .modal-dimmer {
	        top: 0;
	        bottom: 0;
	        right: 0;
	        left: 0;
	        position: absolute;
	        background: rgba(10, 10, 10, 0.5);
	    }
	    .modal-content {
	        margin: 0 20px;
	        border-radius: 9px;
	        max-height: calc(100vh - 40px);
	        overflow: auto;
	        position: relative;
	        width: 100%;
	        box-shadow: -5px 5px 20px 0 rgba(0, 0, 0, 0.2), 5px -5px 20px 0 rgba(0, 0, 0, 0.2);

	        @media screen and (min-width: 769px) {
	            margin: 0 10px;
	            max-height: calc(100vh - 40px);
	            width: 640px;
	        }
	        >.box {
	            background: #fff;
	            display: flex;
	            align-items: flex-start;
	            justify-content: center;
	            flex-flow: column;
	            >.close {
	                position: absolute;
	                top: 15px;
	                right: 15px;
	                color: rgba(255, 255, 255, 0.2);
	                &:hover {
	                    color: rgba(255, 255, 255, 0.4);
	                    cursor: pointer;
	                }
	            }
	            >.box-header {
	                background: linear-gradient(to bottom, #ff8500, #dc850a);
	                width: 100%;
	                height: 260px;
	                display: flex;
	                align-items: center;
	                justify-content: center;
	                color: #fff;
	                font-size: 1.6em;
	                display: flex;
	                align-items: center;
	                justify-content: center;
	                flex-flow: column;
	                line-height: 1.28571429em;
	                font-weight: 700;
					text-align: center;

	                >.icons {
	                    margin-bottom: 14px;
	                    >.top.right.label {
	                        position: absolute;
	                        top: 0;
	                        right: 0;
	                    }
	                }
	            }
	            >.box-content {
	                width: 100%;
	                padding: 20px;
	                margin-bottom: 1rem;
	                display: flex;
	                align-items: center;
	                justify-content: center;
					flex-flow: column;
					text-align: center;
	            }
	            >.box-actions {
	                padding: 20px;
	                display: flex;
	                width: 100%;
	                align-items: center;
	                justify-content: center;
	                flex-flow: row;
	            }
	        }
	    }
	}

	.fadeDown-enter-active,
	.fadeDown-leave-active {
	    transform: translateY(0);
	    transition: all .15s ease;
	}

	.fadeDown-enter,
	.fadeDown-leave-to {
	    transform: translateY(-10%);
	    opacity: 0
	}
</style>




// WEBPACK FOOTER //
// src/components/notifications/Modal.vue